module.exports = __webpack_public_path__ + "media/images/logo-app-ab6bc3e2.png";